import React from 'react';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import Features from '../components/Features';
import Screens from '../components/Screens';
import Reasons from '../components/Reasons';
import Pricing from '../components/Pricing';
import Flow from '../components/Flow';
import Faq from '../components/Faq';
import Company from '../components/Company';
import Cta from '../components/Cta';

/**
 * セクション順は「課題提起 → 解決策 → 証拠 → 価格 → 導入手順 → 不安の解消 → 信頼 → 行動」。
 * 日本のBtoBサイトで実績のある構成に合わせている。
 */
const HomePage: React.FC = () => (
  <>
    <Hero />
    <Problem />
    <Features />
    <Screens />
    <Reasons />
    <Pricing />
    <Flow />
    <Faq />
    <Company />
    <Cta />
  </>
);

export default HomePage;
